import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  firstNameTitle: {
    defaultMessage: 'First name',
    id: '57XCIM',
    description: 'create driver form: input title',
  },
  lastNameTitle: {
    defaultMessage: 'Last name',
    id: 'bjvrE4',
    description: 'create driver form: input title',
  },
  phoneTitle: {
    defaultMessage: 'Phone',
    id: 'zjEEtB',
    description: 'create driver form: input title',
  },
  phoneFranceDescription: {
    defaultMessage: 'Enter phone number without 0',
    id: 'V8we6R',
    description: 'Phone field note',
  },
  emailTitle: {
    defaultMessage: 'Email',
    id: 'ZjX73y',
    description: 'create driver form: input title',
  },
  birthdayTitle: {
    defaultMessage: 'DATE OF BIRTH',
    id: 'cQB2EL',
    description: 'DATE OF BIRTH field title',
  },
  birthdayMinAge: {
    defaultMessage: 'You need to be at least 18 years of age',
    id: 'bdjV3H',
    description: 'Field validation message',
  },
  licensingAuthorityTitle: {
    defaultMessage: 'Licensing authority',
    id: '/Q8aMx',
    description: 'field title',
  },
  licensingAuthorityDescription: {
    defaultMessage:
      'If multiple authorities license you, choose only one. Learn more about license types <a>here</a>.',
    id: 'EUTZOe',
    description: 'field description',
  },
  phdLicenseNumberTitle: {
    defaultMessage: 'Private Hire Driver License Number',
    id: 'pFGlVW',
    description: 'PHD License Number field title',
  },
  phdLicenseNumberDescription: {
    defaultMessage: 'Full PHD license number from your licensing authority.',
    id: 'NB/idy',
    description: 'input tip',
  },
  nationalInsuranceTitle: {
    defaultMessage: 'NATIONAL INSURANCE NUMBER',
    id: 'N/hPyL',
    description: 'NATIONAL INSURANCE NUMBER field title',
  },
  nationalInsuranceError: {
    defaultMessage: 'Wrong national insurance number, ex. AB123456C.',
    id: '5rqrKE',
    description: 'NATIONAL INSURANCE NUMBER field error message',
  },
  vtcRegistrationNumberTitle: {
    defaultMessage: 'VTC (PRIVATE HIRE) REGISTRATION NUMBER',
    id: 'RdRdnV',
    description: 'FR VTC field title',
  },
  vtcRegistrationNumberDescription: {
    defaultMessage: 'Example: EVTC12345678.',
    id: 'A7nLWH',
    description: 'FR VTC field input tip',
  },
  homeAddressTitle: {
    defaultMessage: 'HOME ADDRESS',
    id: 'rx3Bk0',
    description: 'HOME ADDRESS section title',
  },
  addressLine1Placeholder: {
    defaultMessage: 'Address Line 1',
    id: 'address_line1_title',
    description: 'Address line 1 placeholder',
  },
  addressLine2Placeholder: {
    defaultMessage: 'Address Line 2 (Optional)',
    id: 'address_line2_title',
    description: 'Address line 2 optional placeholder',
  },
  cityPlaceholder: {
    defaultMessage: 'City',
    id: 'address_city_title',
    description: 'City placeholder',
  },
  statePlaceholder: {
    defaultMessage: 'State',
    id: 'address_state_title',
    description: 'State placeholder (US only)',
  },
  zipCodePlaceholder: {
    defaultMessage: 'Zip Code',
    id: 'address_zip_code_title',
    description: 'Zip code placeholder (US only)',
  },
  postcodePlaceholder: {
    defaultMessage: 'Postcode',
    id: 'address_postcode_title',
    description: 'Postcode placeholder',
  },
  createButton: {
    defaultMessage: 'Create',
    id: 'FLNCRh',
    description: 'Create driver button',
  },
});
